import { React, useEffect, useState } from "react";
import CustomInput from "../../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getCategories } from "../features/CountrySclice";
import { getCategoriess } from "../features/CountryCatSclice";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import { v4 as uuidv4 } from 'uuid';
import {
  createNewNewsCat,
  getANewsCat,
  resetState,
  updateANewsCat,
} from "../features/CountryDataSclice";

let schema = yup.object().shape({
  id: yup.string(),
  courseName: yup.string().required("Course Name is Required"),
  courseDescription: yup.string().required("Course Description is Required"),
  thumbnail: yup.string().required("Thumbnail is Required"),
  websiteUrl: yup.string().required("Website Url is Required"),
});

const AddNewscat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const bCatState = useSelector((state) => state.country.bCategories);
  const bCatStatee = useSelector((state) => state.countryCat.bCategories);
  const pathSegments = location.pathname.split("/");
  const getNewsCatId = pathSegments[3];
  const getNewsCatIdd = pathSegments[4];
  const getNewsCatIddd = pathSegments[5];

  const newNewsCategory = useSelector((state) => state.countryData);
  const [uuid, setUuid] = useState(uuidv4());
  const {
    isSuccess,
    isError,
    isLoading,
    createNewsCategory,
    courseName,
    courseDescription,
    thumbnail,
    websiteUrl,
    videoUrls,
    text,
    auidoUrls,
    updatedNewsCategory,
  } = newNewsCategory;

  useEffect(() => {
    if (getNewsCatId !== undefined && getNewsCatIdd !== undefined && getNewsCatIddd !== undefined) {
      dispatch(getCategories());
      dispatch(getANewsCat({ id: getNewsCatIddd, cityId: getNewsCatIdd, subcollectionId: getNewsCatId }));
    } else {
      dispatch(resetState());
      dispatch(getCategories());
    }
  }, [getNewsCatId, getNewsCatIdd]);


  useEffect(() => {
    if (isSuccess && (createNewsCategory || updatedNewsCategory)) {
      const successMessage = getNewsCatId !== undefined ? "Updated" : "Added";
      toast.success(`Country Data ${successMessage} Successfully!`);
      navigate("/admin/Country-Data-List");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      hexCode: "#ff9d96",
      order: 0,
      id: getNewsCatIddd || uuid,
      courseName: courseName || "",
      courseDescription: courseDescription || "",
      thumbnail: thumbnail || "",
      websiteUrl: websiteUrl || "",
      text: text || "",
      auidoUrls: auidoUrls || "",
      videoUrls: videoUrls || ""
    },
    validationSchema: schema,
    onSubmit: (values) => {
      const textArray = values.text.split("&").map(link => link.trim());
      const auidoUrlsArray = values.auidoUrls.split("&").map(link => link.trim());
      const videoUrlsArray = values.videoUrls.split("&").map(link => link.trim());

      const updatedValues = {
        ...values,
        text: textArray,
        auidoUrls: auidoUrlsArray,
        videoUrls: videoUrlsArray,
        updatedTime: new Date().toISOString(), // Current time in ISO format
        uploadedTime: new Date().toISOString(),
        isWebsiteRedirect:true
      };
      if (getNewsCatId !== undefined) {
        dispatch(updateANewsCat({ id: getNewsCatIddd, secondId: getNewsCatIdd, subcollectionId: getNewsCatId, NewsCatData: updatedValues }));
      } else {
        dispatch(createNewNewsCat(updatedValues));
        formik.resetForm();
      }
      dispatch(resetState());

    },
  });
  const handleCountryChangeWrapper = (event) => {
    formik.handleChange("countryNamee")(event); // Call formik.handleChange
    handleCountryChange(event); // Call handleCountryChange
  };
  const handleCountryChange = (event) => {
    const selectedCountryId = event.target.value;
   
    dispatch(getCategoriess(selectedCountryId));
    // Dispatch an action to get data based on selected country ID
    // You may need to fetch data based on the selected country ID here
  };


  return (
    <div>
      <h3 className="mb-4  title">
        {getNewsCatId !== undefined ? "Edit" : "Add"} Country Data
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          {getNewsCatId === undefined ? (
            <select
              name="countryNamee"
              onChange={handleCountryChangeWrapper}
              onBlur={formik.handleBlur("countryNamee")}
              value={formik.values.countryNamee}
              className="form-control py-3 mt-3"
            >
              <option value="">Select Country Name</option>
              {bCatState.map((i, j) => (
                <option key={j} value={i.data.id}>
                  {i.data.countryName}
                </option>
              ))}
            </select>
          ) : null}

          <div className="error">{formik.touched.countryNamee && formik.errors.countryNamee}</div>
          {getNewsCatId === undefined ? (
            <select
              name="categoryName"
              onChange={formik.handleChange("categoryName")}
              onBlur={formik.handleBlur("categoryName")}
              value={formik.values.categoryName}
              className="form-control py-3 mt-3"
            >
              <option value="">Select Country Category Name</option>
              {bCatStatee.map((i, j) => (
                <option key={j} value={i.data.id}>
                  {i.data.categoryName}
                </option>
              ))}
            </select>
          ) : null}

          <div className="error">{formik.touched.categoryName && formik.errors.categoryName}</div>
          <CustomInput
            type="text"
            name="id"
            onChng={formik.handleChange("id")}
            onBlr={formik.handleBlur("id")}
            val={formik.values.id}
            label="ID"
            id="id"
            disabled={getNewsCatId !== undefined}
          />
          <CustomInput
            type="text"
            name="courseName"
            onChng={formik.handleChange("courseName")}
            onBlr={formik.handleBlur("courseName")}
            val={formik.values.courseName}
            label="Enter Country Name"
            id="courseName"
          />
          <div className="error">
            {formik.touched.courseName && formik.errors.courseName}
          </div>

          <CustomInput
            type="text"
            name="courseDescription"
            onChng={formik.handleChange("courseDescription")}
            onBlr={formik.handleBlur("courseDescription")}
            val={formik.values.courseDescription}
            label="Enter Description"
            id="courseDescription"
          />
          <div className="error">
            {formik.touched.courseDescription && formik.errors.courseDescription}
          </div>

          <CustomInput
            type="text"
            name="thumbnail"
            onChng={formik.handleChange("thumbnail")}
            onBlr={formik.handleBlur("thumbnail")}
            val={formik.values.thumbnail}
            label="Enter Image thumbnail"
            id="thumbnail"
          />
          <div className="error">
            {formik.touched.thumbnail && formik.errors.thumbnail}
          </div>

          <CustomInput
            type="text"
            name="websiteUrl"
            onChng={formik.handleChange("websiteUrl")}
            onBlr={formik.handleBlur("websiteUrl")}
            val={formik.values.websiteUrl}
            label="Enter Website Url"
            id="websiteUrl"
          />
          <div className="error">
            {formik.touched.websiteUrl && formik.errors.websiteUrl}
          </div>

          <CustomInput
            type="text"
            name="text"
            onChng={formik.handleChange("text")}
            onBlr={formik.handleBlur("text")}
            val={formik.values.text}
            label="Enter Text Content And Please Separate Every Url by &"
            id="text"
          />
          <div className="error">
            {formik.touched.text && formik.errors.text}
          </div>

          <CustomInput
            type="text"
            name="auidoUrls"
            onChng={formik.handleChange("auidoUrls")}
            onBlr={formik.handleBlur("auidoUrls")}
            val={formik.values.auidoUrls}
            label="Enter Auido Urls And Please Separate Every Url by &"
            id="auidoUrls"
          />
          <div className="error">
            {formik.touched.websiteUrl && formik.errors.websiteUrl}
          </div>

          <CustomInput
            type="text"
            name="videoUrls"
            onChng={formik.handleChange("videoUrls")}
            onBlr={formik.handleBlur("videoUrls")}
            val={formik.values.videoUrls}
            label="Enter video Urls And Please Separate Every Url by &"
            id="videoUrls"
          />
          <div className="error">
            {formik.touched.videoUrls && formik.errors.videoUrls}
          </div>

          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
            disabled={isLoading}
          >
            {isLoading && (
              <div className="loader"></div>
            )}
            {isLoading ? "" : getNewsCatId !== undefined ? "Edit" : "Add"} Country Data
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewscat;
